import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-lsfc-blue-600 via-lsfc-blue-700 to-lsfc-green-600">
      {/* Header */}
      <header className="bg-white/10 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
          <div className="flex items-center gap-3">
            <img src="/logo_lsfc.png" alt="Los Salias FC" className="w-12 h-12 object-contain" />
            <span className="text-white font-bold text-xl hidden sm:block">Los Salias FC</span>
          </div>
          <Link to="/inscripcion" className="bg-white text-lsfc-blue-600 px-4 py-2 rounded-lg font-semibold hover:bg-gray-100 transition-all text-sm sm:text-base">
            📝 Inscribir Jugador
          </Link>
        </div>
      </header>

      {/* Hero Section */}
      <main className="max-w-7xl mx-auto px-4 py-12">
        <div className="text-center mb-16">
          <img src="/logo_lsfc.png" alt="Los Salias FC" className="w-32 h-32 mx-auto mb-6 object-contain drop-shadow-2xl" />
          <h1 className="text-4xl sm:text-5xl font-bold text-white mb-4 drop-shadow-lg">
            Los Salias Fútbol Club
          </h1>
          <p className="text-xl text-white/80 mb-2">Escuela de Fútbol</p>
          <p className="text-white/60">Sistema de Gestión Deportiva</p>
        </div>

        {/* Access Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {/* Admin Card */}
          <Link to="/login?tipo=admin" className="group">
            <div className="bg-white rounded-2xl shadow-2xl p-8 hover:shadow-3xl transform hover:-translate-y-2 transition-all duration-300">
              <div className="w-20 h-20 bg-gradient-to-br from-lsfc-blue-500 to-lsfc-blue-700 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform">
                <span className="text-4xl">👨‍💼</span>
              </div>
              <h2 className="text-2xl font-bold text-gray-800 text-center mb-3">
                Panel Administrativo
              </h2>
              <p className="text-gray-500 text-center mb-6">
                Gestión de jugadores, pagos, solicitudes y reportes del club
              </p>
              <div className="flex items-center justify-center gap-2 text-lsfc-blue-600 font-semibold group-hover:gap-4 transition-all">
                <span>Acceder</span>
                <span className="text-xl">→</span>
              </div>
            </div>
          </Link>

          {/* Representante Card */}
          <Link to="/login?tipo=representante" className="group">
            <div className="bg-white rounded-2xl shadow-2xl p-8 hover:shadow-3xl transform hover:-translate-y-2 transition-all duration-300">
              <div className="w-20 h-20 bg-gradient-to-br from-lsfc-green-500 to-lsfc-green-700 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform">
                <span className="text-4xl">👨‍👧‍👦</span>
              </div>
              <h2 className="text-2xl font-bold text-gray-800 text-center mb-3">
                Portal de Representantes
              </h2>
              <p className="text-gray-500 text-center mb-6">
                Consulta pagos, información de tus jugadores y estado de cuenta
              </p>
              <div className="flex items-center justify-center gap-2 text-lsfc-green-600 font-semibold group-hover:gap-4 transition-all">
                <span>Acceder</span>
                <span className="text-xl">→</span>
              </div>
            </div>
          </Link>
        </div>

        {/* Quick Actions */}
        <div className="mt-16 text-center">
          <h3 className="text-white/80 text-lg mb-6">Acciones Rápidas</h3>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/inscripcion" className="bg-white/20 backdrop-blur-sm text-white px-6 py-3 rounded-xl hover:bg-white/30 transition-all flex items-center gap-2">
              <span>📝</span>
              <span>Nueva Inscripción</span>
            </Link>
            <a href="https://wa.me/584141234567" target="_blank" rel="noopener noreferrer" className="bg-green-500/80 backdrop-blur-sm text-white px-6 py-3 rounded-xl hover:bg-green-500 transition-all flex items-center gap-2">
              <span>💬</span>
              <span>WhatsApp</span>
            </a>
            <a href="https://instagram.com/lossaliasfc" target="_blank" rel="noopener noreferrer" className="bg-pink-500/80 backdrop-blur-sm text-white px-6 py-3 rounded-xl hover:bg-pink-500 transition-all flex items-center gap-2">
              <span>📸</span>
              <span>Instagram</span>
            </a>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="mt-16 bg-black/20 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto px-4 py-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-white/80">
            <div>
              <h4 className="font-bold text-white mb-3">📍 Ubicación</h4>
              <p className="text-sm">San Antonio de los Altos</p>
              <p className="text-sm">Estado Miranda, Venezuela</p>
            </div>
            <div>
              <h4 className="font-bold text-white mb-3">📞 Contacto</h4>
              <p className="text-sm">Teléfono: +58 414-123-4567</p>
              <p className="text-sm">Email: info@lossaliasfutbolclub.com</p>
            </div>
            <div>
              <h4 className="font-bold text-white mb-3">⏰ Horarios</h4>
              <p className="text-sm">Lunes a Viernes: 3:00pm - 7:00pm</p>
              <p className="text-sm">Sábados: 8:00am - 12:00pm</p>
            </div>
          </div>
          <div className="border-t border-white/20 mt-8 pt-6 text-center text-white/60 text-sm">
            <p>© 2025 Los Salias Fútbol Club. Todos los derechos reservados.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Home;
